import React from 'react';
import LegalLayout from '@/components/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" testId="terms-page">
      <p>
        These Terms govern your use of the BeautyMateUK platform (the
        <strong> Platform </strong>), available at beautymateuk.com. By creating an account or
        booking a service through the Platform, you agree to these Terms and our
        Privacy Policy and Safety Policy.
      </p>

      <h2>1. Who we are</h2>
      <p>
        BeautyMateUK is a technology platform connecting Customers with independent
        beauty and grooming Partners across Harrow, London. We do not provide the
        services ourselves; services are performed by independent self-employed
        Partners.
      </p>

      <h2>2. Eligibility</h2>
      <p>You must be at least 18 years old to create a Customer account.</p>

      <h2>3. Permitted Booking Hours</h2>
      <p>
        For customer safety, partner safety, and operational monitoring,
        BeautyMateUK only permits appointments to be booked and performed through
        the Platform between <strong>06:00 and 23:00 UK local time</strong>. The
        Platform will not knowingly accept or process bookings outside these
        hours. Any arrangement made between a Customer and a Partner outside the
        Platform, or outside the permitted booking hours, is not a BeautyMateUK
        booking and is not covered by BeautyMateUK support, booking protection,
        cancellation handling, payment processing, or dispute support. Partners
        must not encourage Customers to arrange off-platform or out-of-hours
        appointments. BeautyMateUK may suspend or remove any Partner who breaches
        this rule.
      </p>

      <h2>4. Bookings, Payments and Cancellations</h2>
      <p>
        Bookings are subject to Partner acceptance. Payment is handled securely
        via Stripe and includes a 20% platform commission on the service price.
        Cancellation policy is shown at booking time.
      </p>

      <h2>5. Partner Responsibility and Limitation of Platform Liability</h2>
      <p>
        BeautyMateUK operates as a technology platform that enables Customers to
        discover, request, book, and pay for services provided by independent
        Partners. The Partner, and not BeautyMateUK, is responsible for performing
        the booked service with reasonable care and skill, using appropriate
        qualifications, hygiene standards, tools, products, and insurance.
      </p>
      <p>
        Each Partner is solely responsible for any injury, allergic reaction,
        treatment issue, loss, damage, property damage, or other claim arising
        from the Partner's acts, omissions, advice, products, equipment, hygiene
        practices, or performance of the service, except to the extent caused
        directly by BeautyMateUK's own negligence or breach of law.
      </p>
      <p>
        Partners must maintain appropriate insurance, including public liability
        insurance and, where relevant, professional indemnity, malpractice,
        treatment risk, and product liability cover. BeautyMateUK may request
        evidence of insurance at onboarding and at any time during the Partner's
        use of the Platform.
      </p>
      <p>
        Nothing in these Terms excludes or limits any liability that cannot
        legally be excluded or limited, including liability for death or personal
        injury caused by negligence, fraud, fraudulent misrepresentation, or any
        consumer rights that cannot be excluded under applicable law.
      </p>

      <h2>6. Off-Platform Bookings</h2>
      <p>
        For your safety and protection, BeautyMateUK support, booking records,
        payment protection, and dispute handling only apply to bookings made and
        paid through the Platform.
      </p>

      <h2>7. Account</h2>
      <p>
        You are responsible for keeping your account credentials secure. Notify us
        immediately if you suspect unauthorised access.
      </p>

      <h2>8. Governing Law</h2>
      <p>These Terms are governed by the laws of England and Wales.</p>

      <h2>9. Contact</h2>
      <p>Questions: <a href="mailto:support@beautymateuk.com">support@beautymateuk.com</a></p>
    </LegalLayout>
  );
}
